import Login from '../../modules/Auth/components/Login';

function PageLogin() {

    return <><Login/></>

}

export default PageLogin;
